import OutsideClick from './outside-click';

export default {
    OutsideClick
}